import { Redirect } from 'react-router-dom'
import { ROUTE_PATHS } from 'constants/index'

function Home () {
  return <Redirect to={ROUTE_PATHS.predictionMarketMarkets} />
}

export default Home
